// ─────────────────────────────────────────────────────────────
// Pill
// Extracted from App.js.
// ─────────────────────────────────────────────────────────────

import { C } from "../../lib/colors";
import { fmt$ } from "../../lib/format";

export function Pill({ value, positive }) {
  const c = value > 0 ? C.green : value < 0 ? C.red : C.muted;
  return <span style={{ color: c, fontFamily: "monospace", fontWeight: 700 }}>{fmt$(value)}</span>;
}

